import { connect } from 'react-redux';
import View from './component';
import { toSaving } from '../../../../common/components/ChargerTaskForm';
import ChargersTask from '../../../../common/resources/ChargersTask';
import { setMessage } from '../../../../common/components/Notification/actions';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
  alert: (message) => dispatch(setMessage({ message, duration: 3000 })),
  save: (data) => ChargersTask.create({ chargerId: ownProps.chargerId }, toSaving(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
